import { render, staticRenderFns } from "./AddFacebookChannel.vue?vue&type=template&id=0dd2a0c9"
import script from "./AddFacebookChannel.vue?vue&type=script&lang=js"
export * from "./AddFacebookChannel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports